import React from "react";

/**
 * Centered content wrapper — max-w 1280px with responsive gutters.
 */
const Container = ({ as: Tag = "div", className = "", children, ...rest }) => (
  <Tag
    className={`mx-auto w-full max-w-container-max px-margin-mobile md:px-gutter ${className}`}
    {...rest}
  >
    {children}
  </Tag>
);

export default Container;
